import React from "react";
import {observer} from "mobx-react";
import {IDialogConfirmationHandler} from "../../../services/dialog/dialog.service.interface";
import {useServices} from "../../../hooks/use-services.hook";
import styled from "styled-components";
import {StandardDialogPageComponent} from "../../../components/modal/page/standard-dialog-page.component";
import {StandardDialogHeaderComponent} from "../../../components/modal/header/standard-dialog-header.component";
import {StandardDialogContentComponent} from "../../../components/modal/content/standard-dialog-content.component";
import {StandardDialogFooterComponent} from "../../../components/modal/footer/standard-dialog-footer.component";
import {ContinueButtonComponent} from "../../../components/continue-button/continue-button.component";
import {CallCenterPhoneComponent} from "../../../components/call-center-phone/call-center-phone.component";
import {WebContactFormComponent} from "../../../components/web-contact-form/web-contact-form.component";
import {IPspError} from "../../../services/airline-webapi/responses/psp-error";
import {PspErrorDetailsComponent} from "./psp-error-details.component";
import {ExclamationDiamondIcon} from "../../../assets/svg/exclamation-diamond.icon";


const DialogContentWrapperBox = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${props => props.theme.spacing.spacing20};
`

const ErrorMessageTitleBox = styled.div`
    font-size: ${props => props.theme.fontSize.h1};
    font-weight: ${props => props.theme.fontWeight.bold};
    line-height: 1;
    text-align: center;
`;

const ContactUsBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: ${props => props.theme.fontSize.h5};
    font-weight: ${props => props.theme.fontWeight.semiBold};
    gap: ${props => props.theme.spacing.spacing16};
    
`


export const PaymentFailedFatalDialog: React.FC<{dialogHandler: IDialogConfirmationHandler;  pspErrorDetails: IPspError[] | null}> = observer((props) => {
    const services = useServices();


    const onContinueClick = async () => {
        props.dialogHandler.accept();
        await services.navigator.goHome({
            skipRoutingGuards: true
        });
    }

    return (
        <StandardDialogPageComponent>
            <StandardDialogHeaderComponent dialogHandler={props.dialogHandler}/>

            <StandardDialogContentComponent dialogHandler={props.dialogHandler}>
                <DialogContentWrapperBox>
                    <ExclamationDiamondIcon size={3} color={services.theme.currentTheme.colors.danger}/>
                    <ErrorMessageTitleBox>
                        {services.language.translate('A critical error has occurred while processing your payment.')}
                    </ErrorMessageTitleBox>
                    <ContactUsBox>
                        <div>{services.language.translate('Please contact us')}</div>
                        <CallCenterPhoneComponent/>
                        <WebContactFormComponent/>
                    </ContactUsBox>
                    <PspErrorDetailsComponent pspErrorDetails={props.pspErrorDetails}/>
                </DialogContentWrapperBox>
            </StandardDialogContentComponent>

            <StandardDialogFooterComponent dialogHandler={props.dialogHandler} horizontallyCentered={true}>
                <ContinueButtonComponent onClick={onContinueClick} fullWidth={true} />
            </StandardDialogFooterComponent>

        </StandardDialogPageComponent>
    )
});
